import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-518c6edb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CourierStatus" }
const _hoisted_2 = { class: "CourierStatus__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["CourierStatus__circle", {
                'bg-green-500': _ctx.status.id === 2, 
                'bg-yellow-500': _ctx.status.id === 1,
                'bg-red-500': _ctx.status.id === 4
            }])
    }, null, 2),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.status.title), 1)
  ]))
}